import { Component, inject, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormGroup } from '@angular/forms';
import { AgreementRentalForm } from '../../shared-agreement.model';
import { CachedValuesService } from '@services/cached-values';
import { DropdownItem } from '@shared/components/dropdown/dropdown.component';
import { TranslateService } from '@ngx-translate/core';

@UntilDestroy()
@Component({
    selector: 'app-agreement-rental',
    templateUrl: './rental.component.html',
    styleUrl: './rental.component.scss'
})
export class AgreementRentalComponent {
    @Input() public rentalForm: FormGroup<AgreementRentalForm>;
    @Input() public showPotentialValidationMessages: boolean;
    private readonly cachedValuesService = inject(CachedValuesService);
    private readonly translateService = inject(TranslateService);

    public get f() {
        return this.rentalForm.controls;
    }

    public modelYears: DropdownItem<number>[] = this.cachedValuesService.generateNumericDropdownItems(
        this.currentYearPlusOne,
        2000
    );

    public get currentYearPlusOne(): number {
        const currentYear = new Date().getFullYear();
        return currentYear + 1;
    }

    public mileageAnnualOptions: DropdownItem<number>[] = this.getMileageAnnualOptions();
    public getMileageAnnualOptions(): DropdownItem<number>[] {
        const freeMileage = this.translateService.instant('FEATURES.AGREEMENTS.CAR_FREE_MILEAGE') as string;
        const items: DropdownItem<number>[] = [
            { value: 5000, label: `${5000}` },
            { value: 10000, label: `${10000}` },
            { value: 15000, label: `${15000}` },
            { value: 20000, label: `${20000}` },
            { value: 25000, label: `${25000}` },
            { value: 30000, label: `${30000}` },
            { value: -1, label: freeMileage }
        ];

        return items;
    }
}
